import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import { globalServices } from "../../Services/global.service";
import { posServices } from "../../Services/pos.service";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";

const DeactivatePos = ({ show, handleHide, posId }) => {
  const history = useHistory();
  const [reasons, setReasons] = useState([]);
  const { t: translator } = useTranslation();
  const { register, handleSubmit, errors, formState } = useForm();

  useEffect(() => {
    globalServices
      .getPosLogReasons()
      .then((res) => setReasons(res.data))
      .catch((err) => console.log(err));
  }, []);

  const confirmDeactivation = (data) => {
    posServices
      .deactivatePos(posId, data.noteId, data.note)
      .then((res) => {
        history.push("/pos");
      })
      .catch((err) => console.log(err));
  };

  return (
    <Modal show={show} onHide={handleHide} centered>
      <Modal.Header>
        <Modal.Title>{translator("DeactivatePos")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="container">
          <label>{translator("PosLogReason-Label")}</label>
          <select
            ref={register({ required: true })}
            className="form-control"
            defaultValue={0}
            name="noteId"
          >
            <option value="">{translator("Select-Reason")}</option>
            {reasons.map((reason) => {
              return (
                <option
                  key={reason.posLogReasonId}
                  value={reason.posLogReasonId}
                >
                  {translator(reason.reason)}
                </option>
              );
            })}
          </select>
          {errors.noteId && errors.noteId.type === "required" && (
            <p className="text-danger">
              {translator("ValidationMsg-RequiredField")}
            </p>
          )}
          <br />
          <label>{translator("PosLogReason-Note")}</label>
          <textarea
            id="textArea"
            ref={register({ maxLength: 200 })}
            className="form-control"
            rows={4}
            name="note"
          />
          {errors.note && errors.note.type === "maxLength" && (
            <p className="text-danger">
              {translator("ValidationMsg-MaxLength200")}
            </p>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-outline-secondary"
          data-dismiss="modal"
          onClick={handleHide}
        >
          {translator("General-Close")}
        </button>
        <button
          onClick={handleSubmit(confirmDeactivation)}
          type="button"
          className="btn btn-primary"
        >
          {translator("Btn-Deactivate")}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeactivatePos;
